'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var KBucket = require('k-bucket');

var utils = require('./utils');
/**
 * A wrapper around `k-bucket`, to provide easy store and
 * retrival for peers.
 */


var RoutingTable = /*#__PURE__*/function () {
  /**
   * @param {PeerId} self
   * @param {number} kBucketSize
   */
  function RoutingTable(self, kBucketSize) {
    _classCallCheck(this, RoutingTable);

    this.self = self;
    this._onPing = this._onPing.bind(this);

    this._onInit(kBucketSize);
  } // -- Private Methods


  _createClass(RoutingTable, [{
    key: "_onInit",
    value: function () {
      var _onInit2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(kBucketSize) {
        var selfKey;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return utils.convertPeerId(this.self);

              case 2:
                selfKey = _context.sent;
                this.kb = new KBucket({
                  localNodeId: selfKey,
                  numberOfNodesPerKBucket: kBucketSize,
                  numberOfNodesToPing: 1
                });
                this.kb.on('ping', this._onPing);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function _onInit(_x) {
        return _onInit2.apply(this, arguments);
      }

      return _onInit;
    }()
    /**
     * Called on the `ping` event from `k-bucket`.
     * Currently this just removes the oldest contact from
     * the list, without acutally pinging the individual peers.
     * This is the same as go does, but should probably
     * be upgraded to actually ping the individual peers.
     *
     * @param {Array<Object>} oldContacts
     * @param {Object} newContact
     * @returns {undefined}
     * @private
     */

  }, {
    key: "_onPing",
    value: function _onPing(oldContacts, newContact) {
      // just use the first one (k-bucket sorts from oldest to newest)
      var oldest = oldContacts[0]; // remove the oldest one

      this.kb.remove(oldest.id); // add the new one

      this.kb.add(newContact);
    } // -- Public Interface

    /**
     * Amount of currently stored peers.
     *
     * @type {number}
     */

  }, {
    key: "size",
    get: function get() {
      return this.kb.count();
    }
    /**
     * Find a specific peer by id.
     *
     * @param {PeerId} peer
     * @returns {Promise<PeerId>}
     */

  }, {
    key: "find",
    value: function () {
      var _find = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(peer) {
        var key, closest;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return utils.convertPeerId(peer);

              case 2:
                key = _context2.sent;
                closest = this.closestPeer(key);

                if (!(closest && closest.isEqual(peer))) {
                  _context2.next = 6;
                  break;
                }

                return _context2.abrupt("return", closest);

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function find(_x2) {
        return _find.apply(this, arguments);
      }

      return find;
    }()
    /**
     * Retrieve the closest peers to the given key.
     *
     * @param {Buffer} key
     * @returns {PeerId|undefined}
     */

  }, {
    key: "closestPeer",
    value: function closestPeer(key) {
      var res = this.closestPeers(key, 1);

      if (res.length > 0) {
        return res[0];
      }
    }
    /**
     * Retrieve the `count`-closest peers to the given key.
     *
     * @param {Buffer} key
     * @param {number} count
     * @returns {Array<PeerId>}
     */

  }, {
    key: "closestPeers",
    value: function closestPeers(key, count) {
      return this.kb.closest(key, count).map(function (p) {
        return p.peer;
      });
    }
    /**
     * Add or update the routing table with the given peer.
     *
     * @param {PeerId} peer
     * @returns {Promise<void>}
     */

  }, {
    key: "add",
    value: function () {
      var _add = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(peer) {
        var id;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return utils.convertPeerId(peer);

              case 2:
                id = _context3.sent;
                this.kb.add({
                  id: id,
                  peer: peer
                });

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function add(_x3) {
        return _add.apply(this, arguments);
      }

      return add;
    }()
    /**
     * Remove a given peer from the table.
     *
     * @param {PeerId} peer
     * @returns {Promise<void>}
     */

  }, {
    key: "remove",
    value: function () {
      var _remove = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(peer) {
        var id;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return utils.convertPeerId(peer);

              case 2:
                id = _context4.sent;
                this.kb.remove(id);

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function remove(_x4) {
        return _remove.apply(this, arguments);
      }

      return remove;
    }()
  }]);

  return RoutingTable;
}();

module.exports = RoutingTable;